import { Divider, PageHeadline } from 'components/elements';
import { useFind } from 'components/hooks';
import { ReadOnly } from 'components/modules';
import fp from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useMount } from 'react-use';
import { GenderResources } from 'services/resources/catalogs/gender';
import { IReadOnlyResource } from 'services/resources/catalogs/types.d';

export const GenderPage: React.FC = (): JSX.Element => {
  const [state, onFind] = useFind<IReadOnlyResource>(GenderResources);

  const { t } = useTranslation('common');

  useMount(() => onFind());

  return (
    <>
      <PageHeadline
        quote={t('page.read-only.quote')}
        title={t('page.gender.title')}
      />

      <Divider />

      <ReadOnly data={fp.get(['value', 'results'])(state)} m={8} />
    </>
  );
};
